const createZoom2 = (event, pointer, cellElement, cellIndex) => {
    if (cellElement && cellElement.getElementsByTagName('img').length > 0) {
    const largeImgElement = cellElement.getElementsByTagName('img')[0];
    const largeImage = largeImgElement.dataset.srcZoom;
    const largeCaption = largeImgElement.dataset.srcZoomcaption;
    const tooltip = largeImgElement.dataset.tooltipText;
    const zoomDialog = document.querySelector('.modal--zoom');
    const zoomImage = document.createElement('img');
    const zoomCaptionDiv = document.createElement('div');
    const zoomCloseBtn = zoomDialog.querySelector('button');
    const zoomTooltipData = document.getElementById('material-description-tooltip-data');
    const zoomTooltipButton = document.getElementById('material-description-tooltip-button');
    const mouse = {
      originX: 0,
      originY: 0,
      x: 0,
      y: 0,
      updatePosition(evt) {
        const e = evt || window.event;
        const isTouch = evt.type === 'touchmove';

        this.x = isTouch ? e.touches[0].clientX - this.originX : e.clientX - this.originX;
        this.y = isTouch ? e.touches[0].clientY - this.originY : e.clientY - this.originY;
      },
      setOrigin(e) {
        this.originX = e.offsetLeft + Math.floor(e.offsetWidth / 2);
        this.originY = e.offsetTop + Math.floor(e.offsetHeight / 2);
      },

    };

    const copyToClipboard = (v) => {
        var el = document.createElement('textarea');
        el.value = v;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    };

    const panImage = (x, y) => {
      const translateY = (-zoomImage.offsetHeight / 2) + y;
      zoomImage.style.transform = `translateY(${translateY}px) translateX(-50%)`;
    };

    const mouseMoveHandler = (e) => {
      requestAnimationFrame(() => {
        mouse.updatePosition(e);
        panImage(mouse.x, mouse.y);
      });
    };

    if (largeCaption) {
        zoomCaptionDiv.innerHTML = largeCaption;
        zoomDialog.appendChild(zoomCaptionDiv);
    }

    if (tooltip && zoomTooltipData) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = tooltip;
        zoomTooltipData.innerHTML = wrapper.firstChild.querySelector('p').innerHTML;

        if (zoomTooltipButton) {
            if (tooltip.length > 350) {
                zoomTooltipButton.style.display = "block";
            } else {
                zoomTooltipButton.style.display = "none";
            }
        }        

    } else if (zoomTooltipButton) {
        zoomTooltipButton.style.display = "none";
    }

    //copyToClipboard((largeImage.substring(largeImage.lastIndexOf("/")+1)).split('.')[0]);

    var isMobile = false;
/*
    var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    zoomImage.onload = () => {
        if (!isMobile) {
            return;
        }
        var imgWidth = zoomImage.clientWidth;
        var imgHeight = zoomImage.clientHeight;
        var screenWidth = window.innerWidth;
        var screenHeight = window.innerHeight;
        var scale = Math.min(screenWidth / imgWidth, screenHeight / imgHeight);
        zoomImage.style.transform = `translateY(-50%) translateX(-50%) scale(` + scale + `)`;
    };
*/
    zoomImage.setAttribute('src', largeImage);
    zoomImage.style.zIndex = -1;

    zoomDialog.appendChild(zoomImage);

    const zoomDialogModal = new Modal(zoomDialog);

    const closeZoomModal = (e) => {
          
        if (e.srcElement != null && e.srcElement.classList.contains('js-tooltip'))
        {
            return;
        }
        zoomDialogModal.close(e);
        zoomImage.remove();
        zoomCaptionDiv.remove();
    };

    zoomDialogModal.open();
    mouse.setOrigin(zoomDialog);

    if (event.type === 'touchend' || event.pointerType === 'touch') {
      if (!isMobile) {
        zoomDialog.addEventListener('touchmove', mouseMoveHandler);
      }
      zoomCloseBtn.addEventListener('click', closeZoomModal);
    } else {
      zoomDialog.addEventListener('click', closeZoomModal);
      zoomDialog.addEventListener('mousemove', mouseMoveHandler);
    }
  }
};
